import { createDaysInMonth } from './createDaysInMonth';

const validateDay = (value) => {
  const { day, month, year } = value;
  const days = createDaysInMonth(month, year);

  return days.find((currentDay) => parseInt(day, 10).toString() === currentDay.value);
};

const validateAgeRestriction = (value: { day: string; month: string; year: string }) => {
  const { day, month, year } = value;

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();

  const eighteenYearsAgoDate = new Date(currentYear - 18, currentMonth - 1, currentDay);

  const selectedDate = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));

  return selectedDate <= eighteenYearsAgoDate;
};

export { validateAgeRestriction, validateDay };
